<div class="row comparison-container">
  <div class="col">
    <div class="d-flex align-items-center justify-content-center">
      <div *ngFor="let item of compareService.getAll(); trackBy: equipmentItemService.trackBy" class="comparison-item">
        <div class="d-flex justify-content-center align-items-center flex-column">
          <img [src]="image(item)" class="image" />
          <hr />
          <astrobin-equipment-item-display-name [item]="item"></astrobin-equipment-item-display-name>
          <span (click)="compareService.remove(item)" class="remove">&times;</span>
        </div>
      </div>
    </div>
  </div>
  <div class="col-2">
    <div class="buttons d-flex justify-content-center align-items-center flex-column me-5">
      <button
        [disabled]="compareService.amount() === 1"
        (click)="compare()"
        class="btn btn-primary btn-block btn-lg mb-2"
      >
        {{ "Compare" | translate }}
      </button>

      <button (click)="compareService.clear()" class="btn btn-secondary btn-block btn-lg">
        {{ "Close" | translate }}
      </button>
    </div>
  </div>
</div>
